import React from 'react';
import { Loader2 } from 'lucide-react';

const EventContentSkeleton = ({ view, title, status }) => {
  const isStory = title === 'Story';
  const loadingText =
    status === 'regenerating' || status === 'regeneration' ? 'Regenerating' : 'Generating';

  /* ── Month grid ── */
  if (view === 'dayGridMonth' || !view) {
    return (
      <>
        <div
          className='relative flex items-center gap-1.5 px-1.5 py-1 overflow-hidden rounded cursor-not-allowed w-full opacity-60 pointer-events-none'
          style={{ background: 'var(--bg-surface)', border: '1px solid var(--border)' }}
        >
          {/* Thumbnail placeholder */}
          <div
            className='rounded flex-shrink-0 animate-pulse'
            style={{
              width: isStory ? '18px' : '22px',
              height: isStory ? '30px' : '22px',
              background: 'var(--bg-card-alt)',
            }}
          />
          <div className='flex flex-col gap-0.5 flex-1 min-w-0'>
            <div className='h-3 w-10 rounded animate-pulse' style={{ background: 'var(--bg-card-alt)' }} />
            <div className='h-2.5 w-8 rounded animate-pulse' style={{ background: 'var(--bg-card-alt)' }} />
          </div>
          <Loader2 className='w-3 h-3 animate-spin flex-shrink-0' style={{ color: 'var(--brand)' }} />
        </div>
        <div className='absolute -top-2.5 -right-0.5 z-10'>
          <div className='w-3 h-3 rounded-full animate-pulse' style={{ background: 'var(--bg-card-alt)' }} />
        </div>
      </>
    );
  }

  /* ── List / Day view ── */
  if (view === 'listWeek' || view === 'timeGrid1Day') {
    return (
      <div
        className='relative flex items-center gap-4 p-3 cursor-not-allowed rounded opacity-60 pointer-events-none w-full'
        style={{ background: 'var(--bg-surface)', border: '1px solid var(--border)' }}
      >
        <div className='flex flex-col gap-2 min-w-0 flex-1'>
          <div className='h-3.5 w-14 rounded animate-pulse' style={{ background: 'var(--bg-card-alt)' }} />
          <div className='h-3.5 w-10 rounded animate-pulse' style={{ background: 'var(--bg-card-alt)' }} />
          <div className='h-4 w-16 rounded animate-pulse' style={{ background: 'var(--bg-card-alt)' }} />
        </div>
        <div
          className='rounded-lg flex flex-col items-center justify-center gap-1 animate-pulse flex-shrink-0'
          style={{
            width: isStory ? '56px' : '80px',
            height: isStory ? '96px' : '80px',
            background: 'var(--bg-card-alt)',
          }}
        >
          <Loader2 className='w-5 h-5 animate-spin' style={{ color: 'var(--brand)' }} />
          <span className='text-[10px] text-center px-1' style={{ color: 'var(--text-faint)' }}>
            {loadingText}
          </span>
        </div>
      </div>
    );
  }

  /* ── Default (timeGridWeek etc.) ── */
  return (
    <>
      <div
        className='relative flex items-center overflow-hidden p-1 cursor-not-allowed rounded opacity-60 pointer-events-none'
        style={{ background: 'var(--bg-surface)', border: '1px solid var(--border)' }}
      >
        <div className='flex items-center gap-1.5 flex-1 min-w-0'>
          <div
            className='rounded flex-shrink-0 animate-pulse'
            style={{
              width: isStory ? '14px' : '18px',
              height: isStory ? '24px' : '18px',
              background: 'var(--bg-card-alt)',
            }}
          />
          <div className='flex flex-col gap-0.5 flex-1 min-w-0'>
            <div className='h-3 w-10 rounded animate-pulse' style={{ background: 'var(--bg-card-alt)' }} />
            <div className='h-2 w-8 rounded animate-pulse' style={{ background: 'var(--bg-card-alt)' }} />
          </div>
        </div>
      </div>
      <div className='absolute -top-2 -right-0.5 z-[9999]'>
        <div className='w-4 h-4 rounded-full animate-pulse' style={{ background: 'var(--bg-card-alt)' }} />
      </div>
    </>
  );
};

export default EventContentSkeleton;
